import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/reabertura-viagem`

    return {
        index(queryParms = {}) {
            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        list(queryParms = {}) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        reopen(id) {
            return repository.get(`${baseUrl}/reopen/${id}`)
        },
        getCidades(queryParms = {}) {
            return repository.get(`${baseUrl}/cidade?${urlUtil.serialize(queryParms)}`)
        },
        getDestinos(queryParms = {}) {
            return repository.get(`${baseUrl}/destino?${urlUtil.serialize(queryParms)}`)
        }
    }
}